import { getOcrData } from '../../common/constants/api';
export const OCREvent = (data, ocr_ok, ocr_not_ok) => {
  try {
    getOcrData(data)
      .then(response => {
        let userData = response;

        ocr_ok(userData);
      })
      .catch(err => {
        // alert('Some Error occured Clik ok to continue');
      });
  } catch (e) {
    ocr_not_ok(e);
  }
};
